import React from "react";
import styles from "./FranchiseTableRow.module.css";
import classnames from "classnames";
import {Actions} from "../../../../elements/actions/Actions";
import {FormName} from "../../../../elements/formProvider/formSlice";
import {PopupModalName} from "../../../../elements/popupModalProvider/popupModalSlice";
import {Link} from "react-router-dom";
import {FranchiseListItem} from "../../franchiseSlice";

interface FranchiseTableRowProps {
    index: number;
    franchise: FranchiseListItem;
    isLastRow: boolean;
}

export const FranchiseTableRow: React.FC<FranchiseTableRowProps> = ({
    index,
    franchise,
    isLastRow
}) => {
    return <div
        className={classnames(
            styles.wrapper,
            isLastRow && styles.lastRow,
            franchise.hasWarnings && styles.hasWarning
        )}
    >
        <Link className={styles.rowLink} to={`/franchises/${franchise.publicId}`}>
            <span className={styles.nameCell}>{franchise.name}</span>
            <span className={styles.hashCell}>{franchise.franchiseHash || "—"}</span>
            <span className={styles.urlPatternCell}>{franchise.urlPathPattern || "—"}</span>
        </Link>
        <span className={styles.actionsCell} onClick={event => event.stopPropagation()}>
            <Actions
                index={index}
                publicId={franchise.publicId}
                editFormName={FormName.UPDATE_FRANCHISE}
                deleteModalName={PopupModalName.DELETE_FRANCHISE}
                canBeDeleted={!!franchise.canBeDeleted}
                formProps={{franchise}}
                entityName={franchise.name}
            />
        </span>
    </div>;
};
